import { enqueueSnackbar as notistackEnqueueSnackbar } from "notistack";
import type { OptionsObject, VariantType } from "notistack";

export default function enqueueSnackbar<Variant extends VariantType>(
  message: string,
  variant?: Variant,
  options?: Omit<OptionsObject<Variant>, "variant">
) {
  message = message.trim();

  if (![".", "!", "?"].includes(message[message.length - 1])) {
    message = `${message}.`;
  }

  const snackbarOptions: typeof options = {
    ...(options || {}),
  };

  return notistackEnqueueSnackbar(message, {
    variant: variant as VariantType,
    ...snackbarOptions,
  });
}
